export function assignMatchingFields<T extends Object>(target: T, source: Partial<T>): void {
  Object.keys(source).forEach(key => {
    if (key in target && (source as any)[key] != null  && (source as any)[key] != undefined) {
      (target as any)[key] = (source as any)[key];
    }
  });
}